export default "__VITE_ASSET__e613d764__"